import loadable from '@loadable/component';

import { hydrateOnDemand } from 'utils/hydrateOnDemand/hydrateOnDemand';

export const PageFooterOnDemand = hydrateOnDemand(
  loadable(() => import('./PageFooter'), {
    resolveComponent: (module) => module.PageFooter,
  }),
);
